var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5537 83.3334H8.44623L50 8.19531L91.5537 83.3334ZM15.5121 79.1667H84.4879L50 16.8048L15.5121 79.1667ZM53.7037 71.2963C53.7037 73.3221 52.0254 75.0001 50 75.0001C47.9164 75.0001 46.2963 73.3799 46.2963 71.2963C46.2963 69.2131 47.9164 67.5926 50 67.5926C52.0254 67.5926 53.7037 69.271 53.7037 71.2963ZM47.3377 46.2964V33.3334H52.6619V46.2964L51.2731 62.2687H48.7269L47.3377 46.2964Z",
    fill: "#EEC100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert-warning.7380d44f001a17664d039329957df687.svg";
export { ForwardRef as ReactComponent };